module.exports = __webpack_public_path__ + "img/city_and_street.06084a87.jpg";